window.createManualSwymButtons = async function (container) {
    if (typeof window.SwymAPI === 'undefined' || !window.SwymAPI) return;

    const products = container.querySelectorAll('.limespot-recommendation-box-item');
    if (products.length === 0) return;

    let swymWishlist = await getSwymWishlist();

    products.forEach(product => {
        if (product.querySelector('.swym-button')) return;

        const productId = parseInt(product.getAttribute('data-product-identifier') || product.getAttribute('data-product-id')) || 0;
        let variantId = parseInt(product.getAttribute('data-variant-id') || product.getAttribute('data-variant-identifier')) || 0;
        const productUrl = product.getAttribute('data-product-url') || product.getAttribute('data-display-url');
        const productTitle = product.getAttribute('data-product-title') || product.getAttribute('data-product-name');

        if (!productId) return;

        const button = document.createElement('button');
        button.setAttribute('aria-label', 'Save to wishlist');
        button.classList.add('swym-button', 'swym-add-to-wishlist-view-product', 'swym-btnlink', 'swym-heart', 'swym-loaded', `product_${productId}`);
        if (swymWishlist.includes(parseInt(productId))) {
            button.classList.add('swym-added');
        }
        product.appendChild(button);

        button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (e.target.classList.contains('swym-added')) {
                customRemoveFromWishlist(e, variantId, productId, productUrl, productTitle);
            } else {
                customAddToWishlist(e, variantId, productId, productUrl, productTitle);
            }
        });
    });

    async function customRemoveFromWishlist(e, epi, empi, du, dt) {
        epi = await getProductVariantId(du) || epi;
        const request = { epi: parseInt(epi), empi: parseInt(empi), du, dt };
        try {
            window.SwymAPI.removeFromWishList(
                request,
                () => e.target.classList.remove('swym-added'),
                () => new Error('Error removing from SWYM wishlist')
            );
        } catch (error) {
            console.error('Error:', error);
        }
    }

    async function customAddToWishlist(e, epi, empi, du, dt) {
        epi = await getProductVariantId(du) || epi;
        const request = { epi: parseInt(epi), empi: parseInt(empi), du, dt };
        try {
            window.SwymAPI.addToWishList(
                request,
                () => e.target.classList.add('swym-added'),
                () => new Error('Error adding to SWYM wishlist')
            );
        } catch (error) {
            console.error('Error:', error);
        }
    }

    async function getProductVariantId(url) {
        const productHandle = url ? url.split('/products/')[1]?.split('?')[0] : null;
        if (!productHandle) return null;
        return fetch(`/products/${productHandle}.js`)
            .then(r => r.json())
            .then(data => data.variants[0].id.toString())
            .catch(error => { console.error('\nError fetching product data', error); return null; });
    }

    function getSwymWishlist() {
        return new Promise((resolve, reject) => {
            const timer = setTimeout(() => reject(new Error('Swym fetch timed out')), 1500);
            try {
                window.SwymAPI.fetch((wishlist) => {
                    clearTimeout(timer);
                    resolve(wishlist.map(item => item.empi));
                });
            } catch (err) {
                clearTimeout(timer);
                reject(err);
            }
        });
    }
};

// Initialise Swym buttons for LimeSpot containers after SwymAPI is ready.
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwym);
} else {
    initSwym();
}

function initSwym() {
    setTimeout(function () {
        if (typeof window.SwymAPI !== 'undefined' && window.SwymAPI) {
            document.querySelectorAll('.limespot-recommendation-box').forEach(container => {
                window.createManualSwymButtons(container);
            });
        }
    }, 4000);
}
